import getters from './getters'
import actions from './actions'
import mutations from './mutations'

let accessToken = localStorage.getItem('access_token')

const state = {
  authUser: {
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('access_token'),
    logined: !!accessToken
  },
  userInfo: {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
